import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Invoice, Type } from 'models/invoice';
import { Box, Typography, Paper, Grid } from '@mui/material';
import { formatCurrency } from 'utils/format';

type InvoiceTotalProps = {
    invoice: Invoice;
};
const InvoiceTotal: FC<InvoiceTotalProps> = ({ invoice }: InvoiceTotalProps) => {
    const { t: translate } = useTranslation(['orders', 'client-directory', 'invoices']);

    return (
        <Paper variant="outlined">
            <Box p={2}>
                <Grid container columnSpacing={2}>
                    <Grid item sm={4} md={3}>
                        <Box>
                            <Typography variant="subtitle2">{translate('TOTAL_EXCL_VAT')}</Typography>
                        </Box>
                        <Box>{formatCurrency(invoice?.total?.total, invoice?.total?.currency)}</Box>
                    </Grid>
                    <Grid item sm={4} md={3}>
                        <Box>
                            <Typography variant="subtitle2">{translate('VAT')}</Typography>
                        </Box>
                        <Box>{formatCurrency(invoice?.total?.vat, invoice?.total?.currency)}</Box>
                    </Grid>
                    <Grid item sm={4} md={3}>
                        {invoice.type === Type.CREDIT ? (
                            <Box>
                                <Typography variant="subtitle2">{translate('invoices:IS_CREDITED')}</Typography>
                            </Box>
                        ) : (
                            <Box>
                                <Typography variant="subtitle2">{translate('TOTAL_TO_PAY')}</Typography>
                            </Box>
                        )}
                        <Box>{formatCurrency(invoice?.total?.totalIncVat, invoice?.total?.currency)}</Box>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

export default InvoiceTotal;
